<!-- Modal Header -->
<!-- <div class="modal-header" *ngIf="isModal==true">
<h4 class="modal-title">Pending Accounts</h4>
<button type="button" class="btn-close" data-dismiss="modal" tabindex=-1 (click)="reset()"
aria-label="Close"></button>
</div> -->

<!-- <div class="modal-body"> -->
<div class="p-3">
  <h2>Account Authorization List ({{ pendingAuthorizations.length }})</h2>

  @if (pendingAuthorizations.length > 0 && accountsList.length > 0) {
    @for (auth of pendingAuthorizations; track auth) {
      <div>
        <app-account-authorization-card [authorization]="auth" [customerAccount]="getAccount(auth.CustomerAccountId)"></app-account-authorization-card>
      </div>
    }
  } @else {
    <p>Do not have any account authorization request</p>
  }
</div>
<!-- </div> -->
